function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".plot-handle-button-1{fill:#292929;}.plot-handle-button-2{fill:#3ca3e8;}.plot-handle-button-3{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Landing_w_Project",
  "data-name": "Landing w/ Project"
}, /*#__PURE__*/React.createElement("path", {
  className: "plot-handle-button-1",
  d: "M13.09,24.18A11.09,11.09,0,1,1,24.18,13.09,11.1,11.1,0,0,1,13.09,24.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "plot-handle-button-2",
  d: "M13.09,4A9.09,9.09,0,1,1,4,13.09,9.1,9.1,0,0,1,13.09,4m0-4A13.09,13.09,0,1,0,26.18,13.09,13.09,13.09,0,0,0,13.09,0Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "plot-handle-button-3",
  x: 11.66,
  y: 12.32,
  width: 2.86,
  height: 5.71
}), /*#__PURE__*/React.createElement("rect", {
  className: "plot-handle-button-3",
  x: 15.95,
  y: 10.89,
  width: 2.86,
  height: 7.14
}), /*#__PURE__*/React.createElement("rect", {
  className: "plot-handle-button-3",
  x: 7.38,
  y: 8.03,
  width: 2.86,
  height: 10
})));

function SvgPlotHandleButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.18 26.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotHandleButton);
export default __webpack_public_path__ + "static/media/PlotHandleButton.c72c3269.svg";
export { ForwardRef as ReactComponent };